/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Write_FailedInputs */

const en_us2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save. Try again.`)
};

const pt_br2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para salvar. Tente de novo.`)
};

const es_419_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar. Inténtalo de nuevo.`)
};

const pt_pt2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível guardar. Tenta de novo.`)
};

const fr_fr2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer. Réessaie.`)
};

const de_de2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen. Versuch es erneut.`)
};

const it_it2_exercise_personal_write_failed = /** @type {(inputs: Exercise_Personal_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio non riuscito. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't save. Try again." |
*
* @param {Exercise_Personal_Write_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_write_failed = /** @type {((inputs?: Exercise_Personal_Write_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Write_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_write_failed(inputs)
	if (locale === "es-419") return es_419_exercise_personal_write_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_write_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_write_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_write_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_write_failed(inputs)
	return en_us2_exercise_personal_write_failed(inputs)
});
export { exercise_personal_write_failed as "exercise-personal.write_failed" }